import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { BasedURL } from "../util/constants";

export default function EventBlog() {
  const [items, setItems] = useState([]);
  const history = useHistory();

  useEffect(() => {
    axios
      .get(`${BasedURL}/news`)
      .then((r) => setItems(r.data.slice(0, 3)))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section className="py-16 bg-white">
      {/* Badge */}
      <div className="flex justify-center mb-12">
        <span
          className="text-white font-semibold text-sm tracking-wide px-10 py-2.5 rounded-lg"
          style={{ background: "#16a34a" }}
        >
          Projects
        </span>
      </div>

      {/* 3-column grid */}
      <div className="max-w-5xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((item) => (
          <div
            key={item.id}
            className="bg-white rounded-2xl overflow-hidden"
            style={{ boxShadow: "0 2px 16px rgba(0,0,0,0.09)", display: "flex", flexDirection: "column" }}
          >
            <div style={{ height: 180, background: "#d1d5db", overflow: "hidden", flexShrink: 0 }}>
              {item.imageUrl && (
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              )}
            </div>
            <div style={{ padding: "14px 16px 20px", flex: 1, display: "flex", flexDirection: "column" }}>
              {item.category && (
                <span style={{
                  display: "inline-block",
                  background: "#fef3c7",
                  color: "#92400e",
                  fontSize: 11,
                  fontWeight: 700,
                  borderRadius: 999,
                  padding: "2px 10px",
                  marginBottom: 8,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  alignSelf: "flex-start",
                }}>
                  {item.category}
                </span>
              )}
              {item.title && (
                <p style={{ fontSize: 14, fontWeight: 700, color: "#111827", marginBottom: 6, lineHeight: 1.5 }}>
                  {item.title}
                </p>
              )}
              {item.description && (
                <p style={{ fontSize: 13, color: "#374151", marginBottom: 14, lineHeight: 1.6, flex: 1 }}>
                  {item.description.length > 80 ? item.description.slice(0, 80) + "…" : item.description}
                </p>
              )}
              <button
                onClick={() => history.push(`/projects/${item.id}`)}
                style={{
                  background: "#16a34a",
                  color: "white",
                  border: "none",
                  borderRadius: 6,
                  padding: "6px 18px",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  alignSelf: "flex-start",
                }}
              >
                Read More
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* View all link */}
      <div className="flex justify-center mt-10">
        <button
          onClick={() => history.push("/projects")}
          style={{
            background: "transparent",
            color: "#16a34a",
            border: "2px solid #16a34a",
            borderRadius: 8,
            padding: "8px 28px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          View All Projects
        </button>
      </div>
    </section>
  );
}
